import Link from "next/link";
import Image from "next/image";
import { cn } from "@/lib/utils";

/**
 * TargetQA mark: official logo icon (icon-192.png)
 */
export function BrandMark({
  size = 32,
  variant = "brand",
  className,
}: {
  size?: number;
  variant?: "brand" | "onDark";
  className?: string;
}) {
  return (
    <Image
      src="/icon-192.png"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      priority
      className={cn("shrink-0 rounded-[8px] object-contain select-none", className)}
      style={{ width: size, height: size }}
    />
  );
}

export function BrandLogo({
  compact = false,
  variant = "brand",
  className,
}: {
  compact?: boolean;
  variant?: "brand" | "onDark";
  className?: string;
}) {
  return (
    <Link prefetch={false} href="/" className={cn("inline-flex items-center gap-2.5", className)} aria-label="TargetQA home">
      <BrandMark variant={variant} />
      {!compact && (
        <span className={cn("font-display text-[21px] font-bold leading-none tracking-[-0.035em]", variant === "onDark" ? "text-white" : "text-[#13221a]")}>
          Target<span className={variant === "onDark" ? "text-lime" : "text-[#0B996E]"}>QA</span>
        </span>
      )}
    </Link>
  );
}
